import './vendor';
import { AppModule } from './app/app';
import './launcher';
import * as angular from 'angular';
import { environment } from '../environments/environment';

for (const key in environment.angularJSconstants) {
  if (environment.angularJSconstants.hasOwnProperty(key)) {
    const element = environment.angularJSconstants[key];
    angular.module(AppModule).constant(key, element);
  }
}

export { AppModule };
